var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlux(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#2B61D1",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.963 25.862L16 27l-4.218-2.442 1.915-1.109.048-.028.073.042zM25.5 10.5v2.289l-4.152-2.403-1.126-.652-1.126.652-5.278 3.055-1.126.652v1.348l-2.03-1.176-1.127-.652-1.126.652L6.5 15.371V10.5L16 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 15.397v6.111l-5.278 3.056-.007-.004-5.27-3.052v-6.11l5.277-3.058zm-12.929 2.582v3.514L9.536 23.25 6.5 21.493v-3.514l3.036-1.758z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlux);
export default __webpack_public_path__ + "static/media/flux.ef1c731ab212ddf6f76d5ffaca6356fd.svg";
export { ForwardRef as ReactComponent };